import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import CgnAlert from "../toolbox/CgnAlert";
import CgnButtonGroup from "../toolbox/CgnButtonGroup";
import CgnLoader from "../toolbox/CgnLoader";
import CgnMessage from "../toolbox/CgnMessage";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {
  URL,
  optionStatuses,
  
  UserOperationClaimControl,
} from "../../redux/actions/constants";
import { withRouter } from "react-router-dom";
import CgnDatePicker from "../toolbox/CgnDatePicker";
import moment from "moment";
import CgnButton from "../toolbox/CgnButton";
import MachineAddUpdate from "../machine/MachineAddUpdate";
import EmployeeAddUpdate from "../employee/EmployeeAddUpdate";

class MachinePersonelAddUpdate extends Component {
  state = {
    pageTitle: "Makine Personel Ekle",
    pageTitleAdd: "Makine Personel Ekle",
    pageTitleUpdate: "Makine Personel Güncelle",
    pageAddLink: "makine-personel-ekle",
    pageListLink: "makine-personel-listele",
    breadcrumb: [{ text: "Makine Personel", link: "#" }],
    isLoading: false,
    machineArr: [],
    personelArr: [],
    urlSplit: [],
    guid: "",
    machine: "",
    personelName: "",
    entryDate: null,
    endDate: null,
    status: true,
    nameError: "",
    machineGuid: null,
    personelGuid: null,
    isNull: false,
    isOpenModalMachine: false,
    isOpenModalEmployee: false,
    modalButtonIdx: 0,
    entryDateError: "",
    endDateError: "",
    machineNameError: "",
    personelNameError: "",
    alertErrorMessage: "",
    buttons: [
      {
        type: "button",
        color: "secondary",
        text: CgnMessage.clearButton,
        onClick: (event) => this.handleClear(event),
        disabled: this.isLoading,
      },
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ],
    machineModalPlus: false,
    personelModalPlus: false,
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
      machineModalPlus: await UserOperationClaimControl(1071),
      personelModalPlus: await UserOperationClaimControl(1020),
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var statusType = 2; // sadece aktif olanları göstermesi için
    await axios
      .get(URL + "/machines/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.machineName,
            machineGuid: item.machineGuid,
          };
        });
        this.setState({
          machineArr: myArr,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
        });
      });

    // 
    config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/members/getmembers/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: `${item.firstName} ${item.lastName}`,
            personelGuid: item.personelGuid,
          };
        });
        this.setState({
          personelArr: myArr,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
    let urlSplit = window.location.pathname.split("/");
    this.setState({
      urlSplit: urlSplit,
    });
    if (urlSplit.length === 3) {
      this.setState({
        guid: urlSplit[urlSplit.length - 1],
        pageTitle: this.state.pageTitleUpdate,
        isLoading: true,
      });
      this.getById(urlSplit[2]);
     await axios
        .get(URL + "/machinepersonel/get/" + urlSplit[2], config)
        .then((response) => {
          if (this.state.guid) {
            this.setState({
              machineSerialNo: response.data.machineSerialNo,
              machineGuid: response.data.machineGuid,
              personelGuid: response.data.personelGuid,
              entryDate: response.data.entryDate,
              endDate: response.data.endDate,
              status: response.data.status,
              isLoading: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }

  async componentDidUpdate() {
    let urlSplit = window.location.pathname.split("/");
    if (
      urlSplit.length === 2 &&
      this.state.pageTitle !== this.state.pageTitleAdd
    ) {
      this.setState({
        pageTitle: this.state.pageTitleAdd,
        urlSplit: urlSplit,
        name: "",
        taxNo: "",
        taxAdministration: "",
        address: "",
        eMail: "",
        phone: "",
        machineGuid: null,
        personelGuid: null,
        endDate: "",
        entryDate: "",
        status: true,
      });
    }
    if (this.state.status === undefined) {
      this.setState({
        status: true,
      });
    }
    if (
      this.state.isOpenModalMachine &&
      this.props.location.modalAddedMachine !== undefined &&
      this.props.location.modalAddedMachine.isModal !== undefined &&
      this.props.location.modalAddedMachine.isModal === false
    ) {
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var statusType = 2; // sadece aktif olanları göstermesi için
      axios
        .get(URL + "/machines/getlist/" + statusType, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: item.machineName,
            };
          });
          this.setState({
            machineArr: myArr,
            isLoading: false,
          });
          response.data.forEach((element) => {
            if (
              this.props.location.modalAddedMachine.data &&
              element.machineSerialNo ===
                this.props.location.modalAddedMachine.data
            ) {
              this.setState({
                machineGuid: element.guid,
                machineNameError: "",
                alertErrorMessage: "",
              });
            }
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
      this.props.location.modalAddedMachine.isModal = true;
      this.setState({
        isOpenModalMachine: false,
      });
    }
    if (
      this.state.isOpenModalEmployee &&
      this.props.location.modalAddedEmployee !== undefined &&
      this.props.location.modalAddedEmployee.isModal !== undefined &&
      this.props.location.modalAddedEmployee.isModal === false
    ) {
      // 
      config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/members/getmembers/" + 2, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: `${item.firstName} ${item.lastName}`,
            };
          });
          this.setState({
            personelArr: myArr,
            isLoading: false,
          });
          response.data.forEach((element) => {
            if (
              this.props.location.modalAddedEmployee.data &&
              `${element.firstName} ${element.lastName}` ===
                this.props.location.modalAddedEmployee.data
            ) {
              this.setState({
                personelGuid: element.guid,
                personelNameError: "",
              });
            }
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
      this.props.location.modalAddedEmployee.isModal = true;
      this.setState({
        isOpenModalEmployee: false,
      });
    }
  }

  getById(guid) {
    this.setState({
      isLoading: true,
      guid: guid,
    });
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
    this.setState({
      nameError: "",
      alertErrorMessage: "",
    });
    if (name === "name" && value === "") {
      this.setState({
        nameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  handleClear = (event) => {
    this.clearPage();
  };

  clearPage() {
    this.setState({
      machineGuid: null,
      personelGuid: null,
      endDate: "",
      entryDate: "",
      status: true,
      alertErrorMessage: CgnMessage.alertErrorMessage,
      nameError: CgnMessage.textErrorMessage,
      entryDateError: CgnMessage.textErrorMessage,
      endDateError: CgnMessage.textErrorMessage,
      machineNameError: CgnMessage.textErrorMessage,
      personelNameError: CgnMessage.textErrorMessage,
    });
  }

  handleMachineSelectChange(option) {
    if (option) {
      this.setState({
        machineGuid: option.value,
        machineNameError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        machineGuid: null,
        alertErrorMessage: CgnMessage.alertErrorMessage,
        machineNameError: CgnMessage.textErrorMessage,
      });
    }
  }

  addModalMachine = () => {
    this.setState({
      isOpenModalMachine: !this.state.isOpenModalMachine,
    });
  };

  addModalEmployee = () => {
    this.setState({
      isOpenModalEmployee: !this.state.isOpenModalEmployee,
    });
  };

  handlePersonelSelectChange(option) {
    if (option) {
      this.setState({
        personelGuid: option.value,
        personelNameError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        personelGuid: null,
        alertErrorMessage: CgnMessage.alertErrorMessage,
        personelNameError: CgnMessage.textErrorMessage,
      });
    }
  }

  handleEntryDateChange(entryDate) {
    if (entryDate) {
      this.setState({
        entryDate: entryDate,
        entryDateError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        entryDate: "",
        entryDateError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleEndDateChange(endDate) {
    if (endDate) {
      this.setState({
        endDate: endDate,
        endDateError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        endDate: "",
        endDateError: "",
        alertErrorMessage: "",
      });
    }
  }

  handleStatusSelectChange(status) {
    this.setState({ status: status.value });
  }

  handleSave = async (event) => {
    event.preventDefault();
    this.setState({
      alertErrorMessage: "",
      Error: "",
      entryDateError: "",
      endDateError: "",
      machineNameError: "",
      personelNameError: "",
    });
    if (this.state.machineGuid === null) {
      this.setState({
        machineNameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.personelGuid === null) {
      this.setState({
        personelNameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.entryDate === null) {
      this.setState({
        entryDateError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    } else if (
      this.state.machineGuid !== null &&
      this.state.personelGuid !== null &&
      this.state.entryDate !== ""
    ) {
      this.setState({
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var myObj = {
        machineGuid: this.state.machineGuid,
        personelGuid: this.state.personelGuid,
        entryDate: moment(this.state.entryDate).format("DD/MM/YYYY"),
        endDate: this.state.endDate
          ? moment(this.state.endDate).format("DD/MM/YYYY")
          : null,
        status: this.state.status,
      };
      var URLParam = "/machinepersonel/add";
      if (this.state.guid && this.state.urlSplit.length !== 2) {
        URLParam = "/machinepersonel/update";
        myObj = {
          guid: this.state.guid,
          machineGuid: this.state.machineGuid,
          personelGuid: this.state.personelGuid,
          endDate: this.state.endDate
            ? moment(this.state.endDate).format("DD/MM/YYYY")
            : null,
          entryDate: this.state.entryDate,
          status: this.state.status,
        };
      }
      axios
        .post(URL + URLParam, myObj, config)
        .then(() => {
          setTimeout(() => {
            if (this.state.guid) {
              window.location.href = "/makine-personel-listele";
            } else {
              window.location.reload();
            }
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };
  render() {
    return (
      <>
        {(this.state.urlSplit[1] === "makine-personel-ekle" ||
          this.state.urlSplit[1] === "makine-personel-guncelle") && (
          <ContentTop
            breadcrumb={this.state.breadcrumb}
            title={this.state.pageTitle}
            addLink={"/" + this.state.pageAddLink}
            listLink={"/" + this.state.pageListLink}
          />
        )}
        <Row>
          <Col>
            <Form onSubmit={this.handleSave}>
              <Card body>
                <CgnLoader visibled={this.state.isLoading} />

                <Row>
                  <Col lg="6" className="modalSelectCol">
                    <div className="flex-container">
                      <div className="p-0 flexMaxInput">
                        <CgnReactSelect
                          name="machineGuid"
                          label="Makine [*]"
                          placeholder="Makine seçiniz..."
                          selectValue={this.state.machineGuid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handleMachineSelectChange(option)
                          }
                          options={this.state.machineArr}
                          error={this.state.machineNameError}
                        />
                      </div>
                      {this.state.machineModalPlus && (
                        <div className="p-0 flexAddMinButton">
                          <CgnButton
                            type="button"
                            color="secondary"
                            className="modalSelectAddButton"
                            onClick={() => this.addModalMachine()}
                            text={"+"}
                          />
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col lg="6" className="modalSelectCol">
                    <div className="flex-container">
                      <div className="p-0 flexInput">
                        <CgnReactSelect
                          name="personelGuid"
                          label="Personel [*]"
                          placeholder="Personel seçiniz..."
                          selectValue={this.state.personelGuid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handlePersonelSelectChange(option)
                          }
                          options={this.state.personelArr}
                          error={this.state.personelNameError}
                        />
                      </div>
                      {this.state.personelModalPlus && (
                        <div className="p-0 flexAddButton">
                          <CgnButton
                            type="button"
                            color="secondary"
                            className="modalSelectAddButton"
                            onClick={() => this.addModalEmployee()}
                            text={"+"}
                          />
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg="6">
                    <CgnDatePicker
                      name="entryDate"
                      label="Giriş Tarihi [*]"
                      selected={
                        this.state.entryDate &&
                        this.state.entryDate.toString().indexOf("/") > 0
                          ? new Date(
                              this.state.entryDate.split("/")[2] +
                                "-" +
                                this.state.entryDate.split("/")[1] +
                                "-" +
                                this.state.entryDate.split("/")[0]
                            )
                          : this.state.entryDate
                      }
                      onChange={(entryDate) =>
                        this.handleEntryDateChange(entryDate)
                      }
                      error={this.state.entryDateError}
                      maxDate={new Date(2100, 1, 1)}
                      minDate={new Date(1900, 1, 1)}
                      placeholder="GG/AA/YYYY"
                      autoComplete="off"
                    />
                  </Col>

                  <Col lg="6">
                    <CgnDatePicker
                      name="endDate"
                      label="Çıkış Tarihi"
                      selected={this.state.endDate}
                      onChange={(endDate) => this.handleEndDateChange(endDate)}
                      error={this.state.endDateError}
                      maxDate={new Date(2100, 1, 1)}
                      minDate={new Date(1900, 1, 1)}
                      placeholder="GG/AA/YYYY"
                      autoComplete="off"
                    />
                  </Col>
                  <Col lg="4" style={{display:"none"}}>
                    <CgnReactSelect
                      name="status"
                      label="Durumu"
                      isMulti={false}
                      selectValue={this.state.status}
                      options={optionStatuses}
                      onChange={(status) =>
                        this.handleStatusSelectChange(status)
                      }
                    />
                  </Col>
                </Row>

                {this.state.alertErrorMessage && (
                  <CgnAlert
                    color="danger"
                    title={CgnMessage.alertErrorTitle}
                    text={this.state.alertErrorMessage}
                  />
                )}
                <CgnButtonGroup items={this.state.buttons} />
              </Card>
            </Form>
            {(this.state.urlSplit[1] === "makine-personel-ekle" ||
              this.state.urlSplit[1] === "makine-personel-guncelle") && (
              <CgnButtonLink
                color="secondary"
                to={"/" + this.state.pageListLink}
                text={CgnMessage.backButton}
                className="btn-back"
              />
            )}
          </Col>
        </Row>

        <Modal
          isOpen={this.state.isOpenModalMachine}
          toggle={this.addModalMachine}
          className="modal-xl content"
        >
          <ModalHeader className="font-weight-bold">Makine Ekle</ModalHeader>
          <ModalBody className="modalBody">
            <MachineAddUpdate />
          </ModalBody>
          <ModalFooter>
            <CgnButton
              type="button"
              color="secondary"
              onClick={this.addModalMachine}
              text="Kapat"
              className="modalButton"
            />
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.isOpenModalEmployee}
          toggle={this.addModalEmployee}
          className="modal-xl content"
        >
          <ModalHeader className="font-weight-bold">Personel Ekle</ModalHeader>
          <ModalBody className="modalBody">
            <EmployeeAddUpdate />
          </ModalBody>
          <ModalFooter>
            <CgnButton
              type="button"
              color="secondary"
              onClick={this.addModalEmployee}
              text="Kapat"
              className="modalButton"
            />
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default withRouter(MachinePersonelAddUpdate);
